import { get, post, put, remove, handleClientError } from '../lib'

import { Analyzer, AnalyzerBody } from '../../pages/Analyzers/types'

export const getAllAnalyzers = async (
  query: {
    [k: string]: string | number
  } = {}
): Promise<Analyzer[]> => {
  return get<Analyzer[]>({
    path: '/ipa/analyzer',
    query
  })
}

export const createAnalyzer = async (
  body: AnalyzerBody
): Promise<AnalyzerBody> => {
  return post<AnalyzerBody, AnalyzerBody>({
    path: '/ipa/analyzer',
    body
  })
}

export const getAnalyzer = async (id: string): Promise<Analyzer> => {
  return get<Analyzer>({
    path: `/ipa/analyzer/${id}`
  })
}

export const updateAnalyzer = async (data: {
  id: string
  changes: AnalyzerBody
}): Promise<AnalyzerBody> => {
  return put<AnalyzerBody, AnalyzerBody>({
    path: `/ipa/analyzer/${data.id}`,
    body: data.changes
  })
}

export const removeAnalyzer = async (id: string): Promise<null> => {
  return remove({
    path: '/ipa/analyzer',
    id
  })
}

export const removeAnalyzerResults = async (
  analyzerId: string
): Promise<string> => {
  try {
    await remove({
      path: `/ipa/analyzer/${analyzerId}/results`,
      id: ''
    })
    return analyzerId
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    throw handleClientError(e)
  }
}
